// extracted by mini-css-extract-plugin
export default {"chartContainer":"UploadHoursChart_chartContainer__6NsBo","sidebar":"UploadHoursChart_sidebar__wYcp7","chart":"UploadHoursChart_chart__KqAxW"};